import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InteractiveElement, borderRadius, fontSizes, iconButtonSize, styled } from "@iventis/styles";
import React, { useRef, useState } from "react";
import { useClickDetectOutside } from "@iventis/utilities";
import { utcToZonedTime } from "date-fns-tz";
import { CalendarWithInputComponent } from "./calendar-with-date-inputs";

export interface DateFilterProps {
    date: Date;
    onDateChange: (date: Date) => void;
}

export const DateFilterComponent = ({ date, onDateChange }: DateFilterProps) => {
    const [showCalendar, setShowCalendar] = useState(false);

    const containerRef = useRef<HTMLDivElement>(null);

    useClickDetectOutside(
        () => {
            setShowCalendar(false);
        },
        containerRef,
        false
    );

    const changeDate = (modifier: number) => {
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + modifier);
        onDateChange(newDate);
    };

    return (
        <DateFilterContainer ref={containerRef}>
            <InteractiveElement className="increment-button" onClick={() => changeDate(-1)}>
                <FontAwesomeIcon size="lg" icon={["fas", "chevron-left"]} />
            </InteractiveElement>
            <InteractiveElement data-testid="date-filter-calendar-toggled" className="calendar-toggle" onClick={() => setShowCalendar(!showCalendar)}>
                {utcToZonedTime(date, "UTC").toLocaleDateString("en-GB", { year: "numeric", month: "short", day: "numeric" })}
            </InteractiveElement>
            <InteractiveElement className="increment-button" onClick={() => changeDate(1)}>
                <FontAwesomeIcon size="lg" icon={["fas", "chevron-right"]} />
            </InteractiveElement>
            {showCalendar && <CalendarWithInputComponent className="filter-date-calendar" testId="date-filter-calendar" date={date} onDateChange={onDateChange} />}
        </DateFilterContainer>
    );
};

export const DateFilterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    gap: 5px;
    width: 200px;
    height: 55px;
    border-radius: ${borderRadius.standard};
    background-color: ${(props) => props.theme.typographyColors.blank};
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);

    .increment-button {
        width: ${iconButtonSize};
        height: ${iconButtonSize};
        color: ${(props) => props.theme.primaryColors.subduedMono};
    }

    .calendar-toggle {
        width: 100px;
        font-size: ${fontSizes.small};
        font-weight: 500;
        border: 1px solid ${(props) => props.theme.scrollbar.thumbOne};
        border-radius: ${borderRadius.standard};
        padding: 10px;
    }

    .filter-date-calendar {
        border-radius: ${borderRadius.standard};
        position: absolute;
        bottom: 60px;
        right: 0px;
        background-color: white;
    }
`;
